import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';

import choicesSm from './icons/choices-sm.svg';
import choicesLg from './icons/choices.svg';
import dataSm from './icons/data-sm.svg';
import dataLg from './icons/data.svg';
import experimentationSm from './icons/experimentation-sm.svg';
import experimentationLg from './icons/experimentation.svg';
import journeySm from './icons/journey-sm.svg';
import journeyLg from './icons/journey.svg';

export type HeroIconKind = 'choices' | 'data' | 'experimentation' | 'journey';

const SOURCES_LG: Record<HeroIconKind, string> = {
  choices: choicesLg,
  data: dataLg,
  experimentation: experimentationLg,
  journey: journeyLg,
};

const SOURCES_SM: Record<HeroIconKind, string> = {
  choices: choicesSm,
  data: dataSm,
  experimentation: experimentationSm,
  journey: journeySm,
};

type Props = {
  kind: HeroIconKind;
};

export const HeroIcon = ({ kind }: Props) => (
  <picture>
    <source media={BREAKPOINTS.ABOVE_MOBILE} srcSet={SOURCES_LG[kind]} />
    <img src={SOURCES_SM[kind]} alt="" aria-hidden="true" />
  </picture>
);
